import type { PublicSlotKey } from '#packages/apilib';
import type { ComponentFocusModeApi } from './componentFocusModeApi';

export const ComponentFocusModeApiKey: PublicSlotKey<ComponentFocusModeApi> = {
  name: 'ComponentFocusModeApi',
  public: true,
};
